import { render, staticRenderFns } from "./TransportadoraDetalhesHeader.vue?vue&type=template&id=48007309"
import script from "./TransportadoraDetalhesHeader.vue?vue&type=script&lang=js"
export * from "./TransportadoraDetalhesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports